import PageHeader from "app/shared/PageHeader";
import "./Hotels.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { tabViewStates, userInfo } from "app/config/States/users";
import { tableSchema, hotelActiveTabAtom, agTableHotelType } from "app/config/States/agtable";

import {
  Button,
  Dropdown,
  Input,
  message,
  Modal,
  Select,
  Tabs,
  Tag,
} from "antd";

import {
  API_ENDPOINT_FETCH_AIRLINE_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_CLUSTOR_EMAIL_LIST,
  API_ENDPOINT_FETCH_EMAIL_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST,
} from "../Credentials/credentials.constants";
import { apiGet, apiPost } from "app/services/apiServices";

import Loader from "app/shared/Loader";
import HotelRecon from "./components/HotelRecon";
import UnReconciledFlight from "../AppTour/components/OnboardUnReconcilied/UnReconciledFlight";
import TableViewManager from "app/shared/TableViewManager";
import { API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST } from "../Reconcilation/reconcilation.constants";
import { useFetcher } from "react-router-dom";
import EmptyState from "app/shared/EmptyState";
import { agTableRowSize } from "app/config/States/agtable";
import { appMetaConfig } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";
import BulkDownloadWidget from "app/shared/BulkDownloadWidget";
import ReportHistory from "../Flights/components/ReportsHistory";
import { Mixpanel } from "app/config/Mixpanel";
import HotelPage from "./HotelDemo";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import MyyatraTable from "./MyyatraData";
import { serverModeState } from "app/config/States/users";
export default function Flights(props: any) {
  const [activeTab, setActiveTab] = useRecoilState(hotelActiveTabAtom);
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const [tableSchemaInfo, setTableSchema] = useRecoilState<any>(tableSchema);
  const [hotelType, setHotelType] = useRecoilState(agTableHotelType);
  const reconPageRef: any = useRef();
  const [showModal, setShowModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [creatingRequest, setCreatingRequest] = useState(false);
  const [showModelFor, setShowModalFor] = useState("");
  const [reportName, setReportName] = useState("");
  const [tableRowSize, setTableRowSize] = useRecoilState<any>(agTableRowSize);
  const [invoiceNumberColumn, setInvoiceNumberColumn] = useState<any>(null);
  const [useServer, setUseServer] = useRecoilState(serverModeState)
  const domain = getSubdomain();
  useEffect(() => {
    Mixpanel.track("User Landed On Hotel Recon", { Screen: "Hotel Recon" });
    FinkAnalytics("navbar_option_clicked", {
      option_name: "Hotel",
      workspace_name: userDetails.currentWorkspace?.name,
      subdomain: window.location.hostname.split('.')[0],
    });
    if (domain === "newdemo") {
      setActiveTab("0")
      return
    }
    if (
      activeTab === "1" &&
      userDetails?.currentWorkspace?.name !== "MMT Admin"
    ) {
      setActiveTab("0");
    }
  }, [userDetails?.currentWorkspace]);

  // Set initial active tab when schema data is loaded
  useEffect(() => {
    if (tableSchemaInfo && Array.isArray(tableSchemaInfo) && tableSchemaInfo.length > 0) {
      const tabs = getSceneItems();
      if (tabs.length > 0 && !activeTab) {
        setActiveTab(tabs[0].uniqueId);
      }
      // For hotels, activeTab stores uniqueId, so we need to get the current tab info
      const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
      const moduleId = currentTab?.moduleId;
      const schema = tableSchemaInfo?.find((item: any) => item.moduleId === moduleId);
      const columnMapping = schema?.state?.columnMapping || null;
    
      if (columnMapping) {
        const invoiceColumns = columnMapping
          .filter((col: any) => col.column_type === "INVOICE_NUMBER")
          .map((col: any) => col.destination_key);


        setInvoiceNumberColumn(invoiceColumns);
      } else {
        setInvoiceNumberColumn([]);
      }
    }
  }, [tableSchemaInfo, activeTab]);
  const getSceneItems = () => {

    if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo)) {
      return [{ key: "0", label: "Reconciliation", moduleId: "HOTEL_RECON_MMT", tableName: "", uniqueId: "HOTEL_RECON_MMT" }];
    }

    const hotelModules = tableSchemaInfo.filter(
      (schema: any) => {
        return schema.reportType === "HOTEL";
      }
    );

    const tabs = hotelModules.map((schema: any, index) => {
      const tab = {
        key: index.toString(),
        label: schema.tabName || schema.label || schema.name || schema.moduleId,
        moduleId: schema.moduleId,
        tableName: schema.table_name,
        uniqueId: schema.table_name && schema.table_name.trim() !== ''
          ? schema.table_name
          : `${schema.moduleId}_${index}`,
      };
      return tab;
    });
    return tabs;
  };

  const renderScene = () => {
    const tabs = getSceneItems();
    const currentTab = tabs.find(tab => tab.uniqueId === activeTab);

    if (currentTab) {
      return (
        <HotelRecon
          ref={reconPageRef}
          moduleId={currentTab.moduleId}
          tableName={currentTab.tableName}
        />
      );
    }

    // Fallback to default
    return (
      <HotelRecon
        ref={reconPageRef}
        moduleId={appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_MMT"}
      />
    );
  };

  const handleRaiseReportRequest = async () => {
    setCreatingRequest(true);

    // Get the current tab data
    const tabs = getSceneItems();
    const currentTab = tabs.find(tab => tab.uniqueId === activeTab);

    const moduleId = currentTab?.moduleId || "HOTEL_RECON_MMT";
    const tableName = currentTab?.tableName || "hotel_recon_booking";

    let tablePayload =
      (await reconPageRef.current) && reconPageRef.current?.getGridState();
    let payload = {
      moduleId: moduleId,
      table_name: tableName,
      name: reportName,
      email: userDetails?.email,
      type: "HOTEL",
      tablePayload: tablePayload,
      workspaceid:
        userDetails.currentWorkspace?.id ||
        localStorage.getItem("currentWorkspace"),
    };


    const response = await apiPost(
       API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST,
      //"http://192.168.0.159:7003/api/agtable/report/request",
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        content: "We will notify you via email once report is ready",
      });
    }
    setCreatingRequest(false);
    setShowModal(false);
    setShowModalFor("");
    setReportName("");
  };
  const handleViewReports = async (report: any) => {
    if (report.key === "1") {
      reconPageRef.current && reconPageRef.current.exportDataToExcel();
      // setShowModalFor("CREATE");
    } else {
      setShowModalFor("HISTORY");
    }
    setShowModal(true);
  };
  return (
    <div className="Hotels">
      <div className="ScreenContainer">
        <PageHeader
          leftActions={
            <Tabs
              items={getSceneItems()}
              tabBarStyle={{ borderBottom: "none", margin: 0 }}
              activeKey={(() => {
                const tabs = getSceneItems();
                const activeIndex = tabs.findIndex(tab => tab.uniqueId === activeTab);
                return activeIndex >= 0 ? activeIndex.toString() : (tabs.length > 0 ? "0" : "");
              })()}
              onChange={(tabKey: string) => {
                const tabs = getSceneItems();
                const selectedTab = tabs.find((t) => t.key === tabKey);
                if (selectedTab) {
                  setActiveTab(selectedTab.uniqueId);
                }
              }}
            />
          }
          rightActions={
            activeTab ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <TableViewManager
                  moduleId={
                    (() => {
                      const tabs = getSceneItems();
                      const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
                      return currentTab?.moduleId || appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_MMT";
                    })()
                  }
                  createView={(viewName: string) =>
                    reconPageRef.current &&
                    reconPageRef.current.createNewView(viewName)
                  }
                  selectView={(viewId: string) => {
                    setUseServer(true); 
                    // Also set hotelType to SERVER when switching to server mode
                    setHotelType("SERVER");
                    setTimeout(() => {
                      if (reconPageRef.current) {
                        if (reconPageRef.current.loadTableView) {
                          reconPageRef.current.loadTableView(viewId);
                        } else {
                        }
                      }
                    }, 0);
                  }}
                  updateView={(viewId: string) =>
                    reconPageRef.current &&
                    reconPageRef.current.updateTableView(viewId)
                  }
                />
                <div style={{ marginRight: 12, marginLeft: 12 }}>
                  <BulkDownloadWidget
                    getPayload={() =>
                      reconPageRef.current &&
                      reconPageRef.current?.getGridState()
                    }
                    getColumnDefs={() =>
                      reconPageRef.current &&
                      reconPageRef.current?.getAllColumns()
                    }
                    moduleId={
                      (() => {
                        const tabs = getSceneItems();
                        const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
                        return currentTab?.moduleId || appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_ONE";
                      })()
                    }
                    tableName={
                      (() => {
                        const tabs = getSceneItems();
                        const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
                        return currentTab?.tableName || appMetaConfig[domain]?.hotel_recon_table;
                      })()
                    }
                    success={() => setShowModal(false)}
                    invoiceNumberColumn={invoiceNumberColumn}
                  />
                </div>

                <Dropdown.Button
                  onClick={() => {
                    setShowModalFor("CREATE");
                    setShowModal(true);
                  }}
                  menu={{
                    items: [
                      { key: "1", label: "Download Current Table" },
                      { key: "2", label: "Reports Export History" },
                    ],
                    onClick: handleViewReports,
                  }}
                  size="small"
                  style={{ marginLeft: 12 }}
                  type="primary"
                >
                  Download Report
                </Dropdown.Button>

                <div style={{ marginRight: 12, marginLeft: 12 }}>
                  <BulkDownloadWidget
                    getPayload={() =>
                      reconPageRef.current &&
                      reconPageRef.current?.getGridState()
                    }
                    getColumnDefs={() =>
                      reconPageRef.current &&
                      reconPageRef.current?.getAllColumns()
                    }
                    moduleId={
                      (() => {
                        const tabs = getSceneItems();
                        const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
                        return currentTab?.moduleId || appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_ONE";
                      })()
                    }
                    tableName={
                      (() => {
                        const tabs = getSceneItems();
                        const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
                        return currentTab?.tableName || appMetaConfig[domain]?.hotel_recon_table;
                      })()
                    }
                    success={() => setShowModal(false)}
                    type="CSV"
                    invoiceNumberColumn={invoiceNumberColumn}
                  />
                </div>
              </div>
            ) : null
          }
        />

        {/* <div className="TableContainer">
          {userDetails.approval_status === "ALLOWED" ? (
            renderScene()
          ) : userDetails.currentWorkspace?.approval_status &&
            userDetails.currentWorkspace?.approval_status === "PENDING" ? (
            <EmptyState
              title="Need Approval From Client"
              description="Please check if you have added user from this workspace for acknowledgment"
            />
          ) : (
            renderScene()
          )}
        </div> */}

        <div className="TableContainer">
          {domain === "newdemo" ? (
            <HotelPage />
          ) : domain === "myyatra" ? (
            <MyyatraTable />
          ) : userDetails.approval_status === "ALLOWED" ? (
            renderScene()
          ) : userDetails.currentWorkspace?.approval_status === "PENDING" ? (
            <EmptyState
              title="Need Approval From Client"
              description="Please check if you have added user from this workspace for acknowledgment"
            />
          ) : (
            renderScene()
          )}
        </div>


        {/* <div className="TableContainer">
          {domain === "newdemo" ? (
            <HotelPage />
          ) : userDetails.approval_status === "ALLOWED" ? (
            renderScene() 
          ) : userDetails.currentWorkspace?.approval_status === "PENDING" ? (
            <EmptyState
              title="Need Approval From Client"
              description="Please check if you have added user from this workspace for acknowledgment"
            />
          ) : (
            renderScene() 
          )}
        </div> */}


        <Modal
          open={showModal}
          footer={false}
          onCancel={() => setShowModal(false)}
          title={
            showModelFor === "CREATE"
              ? "Create Report Request"
              : "Report Download History"
          }
          width={showModelFor === "CREATE" ? 500 : 800}
        >
          {showModelFor === "CREATE" ? (
            <>
              <Input
                placeholder="Report Name"
                onChange={(e: any) => setReportName(e.target.value)}
                value={reportName}
              />
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{ marginRight: 12 }}
                  onClick={() => setShowModal(false)}
                  loading={creatingRequest}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleRaiseReportRequest}
                  type="primary"
                  loading={creatingRequest}
                >
                  Create
                </Button>
              </div>
            </>
          ) : (
            <ReportHistory
              moduleId={(() => {
                const tabs = getSceneItems();
                const currentTab = tabs.find(tab => tab.uniqueId === activeTab);
                return currentTab?.moduleId || appMetaConfig[domain]?.hotel_recon || "HOTEL_RECON_MMT";
              })()}
            />
          )}
        </Modal>
      </div>
      {contextHolder}
    </div>
  );
}
